import React from "react";
import "./projectComponent.css";
import OptimizedSlideshow from './OptimizedSlideshow';

const VisioWave = () => {
    const mediaItems = [
        {
            type: 'image',
            src: require('./images/visiowaveNobg.png'),
        }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">VisioWave</h2>
        <span className="section__subtitle">
            AI-Powered Image and Video Generation Platform (2023)
            <a href="https://github.com/OuhabYouceff/generativeAI/tree/master" target="_blank" rel="noopener noreferrer" style={{marginLeft: '10px', color: '#333', textDecoration: 'none'}}>
                <i className="bx bxl-github" style={{fontSize: '1.2rem', verticalAlign: 'middle'}}></i>
            </a>
        </span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
            <div className="text__container">
                <h3 className="title">Description:</h3>
                <br />
                <p className='redRadio__text'>
                    VisioWave is an innovative AI-powered platform developed in 2023 that generates high-quality images and videos directly from text prompts. 
                    Built as a pioneering solution before the era of Sora and similar mainstream tools.
                </p>
                <br />
                
                <h4 className="title" style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>Core Capabilities</h4>
                <ul style={{listStyle: 'none', padding: '0', margin: '0'}}>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🎨 Text-to-Image Generation</strong> - Create stunning visuals from descriptive text prompts
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🎬 Text-to-Video Creation</strong> - Generate dynamic video content from written descriptions
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🤗 Hugging Face Integration</strong> - Leverages open-source models from Hugging Face ecosystem
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>⚡ Real-time Processing</strong> - Fast generation pipeline for immediate results
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🎯 Prompt Engineering</strong> - Advanced prompt optimization for better output quality
                    </li>
                </ul>
                <br />
                
                <h4 className="title" style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>Innovation Timeline</h4>
                <p className='redRadio__text'>
                    Developed in 2023 as an early adopter of generative AI technology, predating major commercial releases 
                    like Sora and other mainstream video generation tools. Demonstrates forward-thinking approach to AI-powered content creation.
                </p>
                <br />
                
                <p className='redRadio__text' style={{fontStyle: 'italic'}}>
                    Pioneering AI-driven creative content generation through open-source innovation and cutting-edge prompt engineering.
                </p>
            </div>

            <div className="skills__container1 container grid">
        <div className="skills__content">
        <h3 className="skills__title">Technologies Used</h3>

        <div className="skills__box">

        <div className="skills__group">

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Python</h3>
                <span className="skills__level">Backend</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Hugging Face</h3>
                <span className="skills__level">Models</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Transformers</h3>
                <span className="skills__level">AI</span>
            </div>
            </div>

           
        </div>

        <div className="skills__group">
            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">Flask</h3>
                <span className="skills__level">Framework</span>
              </div>
            </div>

            <div className="skills__data">
              <i class="bx bx-badge-check"></i>
              <div>
                <h3 className="skills__name">Diffusion Models</h3>
                <span className="skills__level">Generation</span>
              </div>
            </div>
             <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">UX/UI</h3>
                <span className="skills__level">Design</span>
            </div>
            </div>


          
        </div>

        </div>
    </div>
            </div>
        </div>
    </section>
    );
};

export default VisioWave;